export function formatPrice(cents, currency = "usd") {
  const amount = (cents || 0) / 100;
  const fmt = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  });
  return fmt.format(amount);
}

export function readApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" · ");
  }
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail === "object") return JSON.stringify(detail);
  return err?.message || fallback;
}
